// Gemeinsame Typen der API-Antworten.
export type StaffArea = 'fibu' | 'lohn' | 'beides';

export interface MeUser {
  id: string;
  email: string;
  name: string;
  kind: 'client' | 'staff';
  isAdmin: boolean;
  area: StaffArea | null;
  // in der App gewählte Sprache, null = noch nie gewählt
  lang?: 'de' | 'en' | 'tr' | 'ar' | null;
}

export type ClientStatus = 'pending' | 'active' | 'rejected';

// Firmen eines Mandanten-Logins (für Wartebildschirm und Firmenwahl)
export interface MeClient {
  id: string;
  name: string;
  number: string | null;
  status: ClientStatus;
  rejectReason: string | null;
  contactName: string;
}

export interface Me {
  user: MeUser;
  clients: MeClient[];
  // Billtoro: Login hat für mindestens eine Firma den Zugang fürs Steuerbüro (die Firmen stehen nicht in clients,
  // sondern unter /mandanten)
  buero?: boolean;
  // Billtoro: Login des Betreibers (BILLTORO_BETREIBER), sieht den Betreiber-Bereich /betreiber; sonst fehlt das Feld
  betreiber?: boolean;
}

export interface AppConfig {
  kanzleiName: string;
  kanzleiPhone: string | null;
  mailEnabled: boolean;
  // Login-Code per E-Mail ist an (E-Mail-Versand eingerichtet und nicht abgeschaltet)
  loginCode?: boolean;
  // Links für das Häkchen bei der Registrierung (fehlen, solange nicht eingestellt)
  agbUrl?: string | null;
  // Stand der AGB, z. B. „10/2026“
  agbStand?: string;
  avUrl?: string | null;
  datenschutzUrl?: string | null;
  // Impressum: unten auf jeder Seite ohne Anmeldung und im Konto-Menü (components/LegalLinks.tsx)
  impressumUrl?: string | null;
  // Kanzlei wird nach so vielen Minuten ohne Eingabe abgemeldet (null = nie)
  idleMinutes?: number | null;
  // Produkt dieser Instanz (wie <html data-produkt>, src/produkt.ts) und sein Name: Billtoro oder der Kanzleiname
  produkt: 'kanzlei' | 'billtoro';
  produktName: string;
  // Billtoro: Adresse des Supports und der Webseite (fehlen, solange nicht eingestellt)
  supportEmail: string | null;
  webseiteUrl: string | null;
  // Billtoro: Registrierung offen, Bezahlung eingerichtet (Stripe), Testtage für neue Firmen (0 = keine)
  signup: boolean;
  billing: boolean;
  testTage: number;
  // Billtoro: Registrierung offen, nur für eingetragene Tester oder noch zu („Billtoro startet bald“); vorschau: die
  // Angaben zum Anbieter fehlen noch (Seiten zeigen „Vorschau“). Fehlt bei älteren Servern: wie „offen“.
  anmeldung?: 'offen' | 'tester' | 'zu';
  vorschau?: boolean;
}

export type Ustva = 'M' | 'Q' | 'J' | 'B';

export const AREA_LABEL: Record<StaffArea, string> = {
  fibu: 'Finanzbuchhaltung',
  lohn: 'Lohn & Gehalt',
  beides: 'FiBu und Lohn',
};
